import type { Pagination, ProductCategory } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/categories';

export function getProductCategories(query?: ProductCategory.SearchQuery) {
    return api.get<Pagination<ProductCategory>>(`${rootPath}`, query);
}

export function getProductCategory(id: number) {
    return api.get<ProductCategory.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postProductCategory(data: ProductCategory.CreateRequest) {
    return api.post<ProductCategory>(`${rootPath}`, data);
}

export function putProductCategory(
    id: number,
    data: ProductCategory.UpdateRequest
) {
    return api.put<ProductCategory>(`${rootPath}/${id}`, data);
}

export function deleteProductCategory({ id }: ProductCategory.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
